import { render, staticRenderFns } from "./IllustrationHeader.vue?vue&type=template&id=50583c7f&scoped=true&"
import script from "./IllustrationHeader.vue?vue&type=script&lang=js&"
export * from "./IllustrationHeader.vue?vue&type=script&lang=js&"
import style0 from "./IllustrationHeader.vue?vue&type=style&index=0&id=50583c7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50583c7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50583c7f')) {
      api.createRecord('50583c7f', component.options)
    } else {
      api.reload('50583c7f', component.options)
    }
    module.hot.accept("./IllustrationHeader.vue?vue&type=template&id=50583c7f&scoped=true&", function () {
      api.rerender('50583c7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/IllustrationHeader.vue"
export default component.exports